// extracted by mini-css-extract-plugin
export default {"historyTitle":"History_historyTitle__336IK"};